<template>
  <hr>
</template>

<script>
  import Vue from "vue";
  import ContentElementComponent from "./content-element-component.vue";

  export default Vue.extend({
    extends: ContentElementComponent
  });
</script>